import { render, staticRenderFns } from "./DmarcSettings.vue?vue&type=template&id=0dd7d4bc&scoped=true"
import script from "./DmarcSettings.vue?vue&type=script&lang=js"
export * from "./DmarcSettings.vue?vue&type=script&lang=js"
import style0 from "./DmarcSettings.vue?vue&type=style&index=0&id=0dd7d4bc&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd7d4bc",
  null
  
)

export default component.exports